import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-black-card-style3',
  templateUrl: './black-card-style3.component.html',
  styleUrls: ['./black-card-style3.component.css']
})
export class BlackCardStyle3Component implements OnInit {

  @Input() right = false;
  // @ts-ignore
  // @ts-ignore
  constructor() { }

  // @ts-ignore
  ngOnInit() {
  }

}
